import React, { useState, useEffect } from 'react';
import { ShoppingCart, Code, Database, Server, Globe, Codepen, ChevronDown, Box } from 'lucide-react';
import './cloudDigital.css'

import saas from './cloud-1.jpg';
import shareMeImg from './cloud-dns.webp';
import foodDeliveryImg from './cloud-dns02.webp';
import shoppingCartImg from './cloud-card.jpg';

const ProjectShowcase = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const images = [saas, shareMeImg, foodDeliveryImg, shoppingCartImg];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [images]);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const projects = [
    {
      title: "Domain name server manager",
      link: 'https://dns-manager-project-s64i.onrender.com/',
      icon: <Globe size={16} />,
    },
    {
      title: "Card tracker courier service",
      link: 'https://github.com/Ashishkr05/Card-Tracker',
      icon: <Box size={16} />,
    },
    {
      title: "Discussion Platform",
      link: 'https://github.com/Ashishkr05/SocialDiscuss-Backend-Application',
      icon: <Code size={16} />,
    }
  ];

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const features = [
    { text: "🌐 Real-time DNS Management" },
    { text: "📦 Card Tracking and Status Management" },
    { text: "👥 User Interaction & Comment System" },
    { text: "🏛️ Scalable Backend Architecture" },
    { text: "🗄️ Database Integration & Management" },
    { text: "🚀 Cloud Deployment on AWS" }
  ];
  
  const technologies = [
    { text: "⚛️ React.js (Frontend)" },
    { text: "🟢 Node.js & Express.js (Backend)" },
    { text: "🍃 MongoDB (NoSQL Database)" },
    { text: "🔗 RESTful API Integration" },
    { text: "🚀 AWS Route 53 (DNS)" },
    { text: "📊 Microservices Architecture" }
  ];

  return (
    <div className="project-showcase">
      <div className="showcase-content">
        <div className="image-carousel">
          <img
            src={images[currentImageIndex]}
            alt={`Project ${currentImageIndex + 1}`}
          />
          <div className="dots-container">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentImageIndex === index ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
        <div className="project-details">
          <h2>🌩️ Cloud & Networking Solutions</h2>
          <p>
          It offer robust tools for managing infrastructure, communication, and collaboration in network environments. This category includes projects like a Domain Name Server (DNS) management platform, a card tracker for network monitoring, and a courier service agent discussion platform. These solutions aim to streamline network operations, enhance communication, and ensure seamless management of cloud and networking tasks.
          </p>
          <div className="features-technologies">
            <div className="column">
              <h3>Key Features</h3>
              {features.map((item, index) => (
                <div key={index} className="item">
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
            <div className="column">
              <h3>Technologies Used</h3>
              {technologies.map((item, index) => (
                <div key={index} className="item">
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="project-dropdown">
            <button className="dropdown-button" onClick={toggleDropdown}>
              Explore Cloud Digital Solutions <ChevronDown size={16} />
            </button>
            <div className={`dropdown-content ${dropdownOpen ? 'show' : ''}`}>
              {projects.map((project, index) => (
                <a
                  key={index}
                  href={project.link}
                  className="project-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {project.icon}
                  <span>{project.title}</span>
                </a>
              ))}
            </div>
          </div>
          <p className="dropdown-note">Click on a product to view detailed information and implementation guides.</p>
        </div>
      </div>
    </div>
  );
};

export default ProjectShowcase;
